import styled from 'styled-components';
import { getSpacing } from 'stylesheet';
var SearchProductWrapper = styled.div.withConfig({
  displayName: "SearchProductstyle__SearchProductWrapper",
  componentId: "sc-18d3f30-0"
})(["display:flex;flex-direction:column;width:100%;height:400px;margin-top:", ";row-gap:", ";"], getSpacing(1), getSpacing(1));
var Description = styled.p.withConfig({
  displayName: "SearchProductstyle__Description",
  componentId: "sc-18d3f30-1"
})(["text-align:center;"]);
export { Description, SearchProductWrapper };